var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_942",
  "data-name": "Rectangle 942",
  width: 426.808,
  height: 138.565,
  fill: "#c00100"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_871",
  "data-name": "Group 871",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1920",
  "data-name": "Path 1920",
  d: "M.051,97.409a.451.451,0,0,1,.433-.664h2.6a.469.469,0,0,1,.435.281L8.419,108H8.6l4.9-10.969a.469.469,0,0,1,.433-.281h2.6a.451.451,0,0,1,.435.664L9.056,114.578a.46.46,0,0,1-.433.28H8.368a.461.461,0,0,1-.435-.28Z",
  transform: "translate(0 23.706)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1921",
  "data-name": "Path 1921",
  d: "M25.568,96.54a9.184,9.184,0,1,1-9.158,9.21,9.167,9.167,0,0,1,9.158-9.21m0,15.051a5.867,5.867,0,1,0-5.842-5.842,5.879,5.879,0,0,0,5.842,5.842",
  transform: "translate(4.021 23.656)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1922",
  "data-name": "Path 1922",
  d: "M38.519,99.807h-3.9a.484.484,0,0,1-.484-.484V97.231a.485.485,0,0,1,.484-.486H45.763a.485.485,0,0,1,.484.486v2.092a.484.484,0,0,1-.484.484h-3.9v14.312a.5.5,0,0,1-.484.484H39a.5.5,0,0,1-.484-.484Z",
  transform: "translate(8.363 23.706)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1923",
  "data-name": "Path 1923",
  d: "M48.041,97.23a.484.484,0,0,1,.484-.484H58.909a.484.484,0,0,1,.484.484v2.092a.484.484,0,0,1-.484.484H51.358v4.185h6.3a.5.5,0,0,1,.484.484v2.118a.485.485,0,0,1-.484.484h-6.3v4.465h7.551a.484.484,0,0,1,.484.484v2.092a.484.484,0,0,1-.484.484H48.525a.484.484,0,0,1-.484-.484Z",
  transform: "translate(11.772 23.706)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1924",
  "data-name": "Path 1924",
  d: "M67.446,97.408a.445.445,0,0,1,.459-.613h2.347a.525.525,0,0,1,.459.357l2.653,10.178h.1l4.055-10.509a.413.413,0,0,1,.435-.281h.459a.412.412,0,0,1,.433.281l4.081,10.509h.1l2.6-10.178a.525.525,0,0,1,.459-.357h2.347a.445.445,0,0,1,.459.613l-4.822,17.143a.49.49,0,0,1-.459.357h-.407a.435.435,0,0,1-.435-.28l-4.566-11.556h-.128l-4.515,11.556a.436.436,0,0,1-.435.28h-.408a.489.489,0,0,1-.458-.357Z",
  transform: "translate(16.52 23.656)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_941",
  "data-name": "Rectangle 941",
  width: 3.342,
  height: 17.856,
  rx: 0.389,
  transform: "translate(110.951 120.452)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1925",
  "data-name": "Path 1925",
  d: "M100.366,99.807h-3.9a.484.484,0,0,1-.484-.484V97.231a.485.485,0,0,1,.484-.486h11.147a.485.485,0,0,1,.486.486v2.092a.484.484,0,0,1-.486.484h-3.9v14.312a.5.5,0,0,1-.484.484H100.85a.5.5,0,0,1-.484-.484Z",
  transform: "translate(23.518 23.706)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1926",
  "data-name": "Path 1926",
  d: "M109.887,97.23a.5.5,0,0,1,.484-.484h2.373a.484.484,0,0,1,.484.484v6.761h8.317V97.23a.484.484,0,0,1,.484-.484h2.347a.5.5,0,0,1,.484.484v16.888a.5.5,0,0,1-.484.484H122.03a.484.484,0,0,1-.484-.484v-7.041h-8.317v7.041a.484.484,0,0,1-.484.484h-2.373a.5.5,0,0,1-.484-.484Z",
  transform: "translate(26.926 23.706)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1927",
  "data-name": "Path 1927",
  d: "M138.172,106.006l-5.817-8.521a.472.472,0,0,1,.408-.74h2.6a.507.507,0,0,1,.408.23l4.081,5.867,4.082-5.867a.506.506,0,0,1,.407-.23h2.628a.472.472,0,0,1,.408.74l-5.893,8.5v8.138a.5.5,0,0,1-.486.484h-2.347a.484.484,0,0,1-.484-.484Z",
  transform: "translate(32.412 23.706)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1928",
  "data-name": "Path 1928",
  d: "M156.125,96.54a9.184,9.184,0,1,1-9.158,9.21,9.167,9.167,0,0,1,9.158-9.21m0,15.051a5.867,5.867,0,1,0-5.842-5.842,5.879,5.879,0,0,0,5.842,5.842",
  transform: "translate(36.012 23.656)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1929",
  "data-name": "Path 1929",
  d: "M166.224,97.23a.5.5,0,0,1,.484-.484h2.424a.484.484,0,0,1,.484.484v10.433a3.715,3.715,0,1,0,7.424.026V97.23a.484.484,0,0,1,.484-.484h2.423a.5.5,0,0,1,.486.484v10.613a7.105,7.105,0,0,1-14.21,0Z",
  transform: "translate(40.731 23.706)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1930",
  "data-name": "Path 1930",
  d: "M183.207,97.23a.484.484,0,0,1,.484-.484h7.3a5.526,5.526,0,0,1,5.562,5.484,5.63,5.63,0,0,1-3.775,5.153l3.495,6.479a.484.484,0,0,1-.435.741h-2.678a.439.439,0,0,1-.408-.23l-3.393-6.761h-2.831v6.505a.5.5,0,0,1-.486.486h-2.347a.485.485,0,0,1-.484-.486Zm7.5,7.653a2.6,2.6,0,0,0,2.525-2.6,2.537,2.537,0,0,0-2.525-2.474h-4.158v5.076Z",
  transform: "translate(44.892 23.706)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1931",
  "data-name": "Path 1931",
  d: "M204.21,97.408a.445.445,0,0,1,.459-.613h2.347a.525.525,0,0,1,.459.357l2.653,10.178h.1l4.055-10.509a.413.413,0,0,1,.435-.281h.459a.412.412,0,0,1,.433.281l4.081,10.509h.1l2.6-10.178a.525.525,0,0,1,.459-.357h2.347a.445.445,0,0,1,.459.613l-4.822,17.143a.49.49,0,0,1-.459.357h-.407a.435.435,0,0,1-.435-.28l-4.566-11.556h-.128l-4.514,11.556a.436.436,0,0,1-.435.28h-.408a.489.489,0,0,1-.458-.357Z",
  transform: "translate(50.032 23.656)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1932",
  "data-name": "Path 1932",
  d: "M223.471,113.989l7.935-17.168a.458.458,0,0,1,.433-.281h.255a.433.433,0,0,1,.433.281l7.857,17.168a.45.45,0,0,1-.433.664h-2.22a.733.733,0,0,1-.74-.51l-1.25-2.755h-7.627l-1.25,2.755a.77.77,0,0,1-.741.51h-2.219a.451.451,0,0,1-.435-.664m11.021-5.433-2.551-5.613h-.076l-2.5,5.613Z",
  transform: "translate(54.746 23.656)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1933",
  "data-name": "Path 1933",
  d: "M240.957,97.23a.484.484,0,0,1,.484-.484h2.347a.5.5,0,0,1,.486.484v14.312h6.505a.484.484,0,0,1,.484.484v2.092a.484.484,0,0,1-.484.484h-9.338a.484.484,0,0,1-.484-.484Z",
  transform: "translate(59.043 23.706)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1934",
  "data-name": "Path 1934",
  d: "M253.35,97.23a.484.484,0,0,1,.484-.484h2.347a.5.5,0,0,1,.486.484v14.312h6.505a.484.484,0,0,1,.484.484v2.092a.484.484,0,0,1-.484.484h-9.338a.484.484,0,0,1-.484-.484Z",
  transform: "translate(62.08 23.706)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1935",
  "data-name": "Path 1935",
  d: "M265.745,97.23a.483.483,0,0,1,.483-.484h10.384a.484.484,0,0,1,.484.484v2.092a.484.484,0,0,1-.484.484h-7.551v4.185h6.3a.5.5,0,0,1,.484.484v2.118a.485.485,0,0,1-.484.484h-6.3v4.465h7.551a.484.484,0,0,1,.484.484v2.092a.484.484,0,0,1-.484.484H266.228a.483.483,0,0,1-.483-.484Z",
  transform: "translate(65.117 23.706)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1936",
  "data-name": "Path 1936",
  d: "M282.629,99.807h-3.9a.484.484,0,0,1-.484-.484V97.231a.485.485,0,0,1,.484-.486h11.148a.485.485,0,0,1,.484.486v2.092a.484.484,0,0,1-.484.484h-3.9v14.312a.5.5,0,0,1-.484.484h-2.373a.5.5,0,0,1-.484-.484Z",
  transform: "translate(68.179 23.706)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1937",
  "data-name": "Path 1937",
  d: "M.034,9.57a2.528,2.528,0,0,1,2.53-2.53H56.748a2.528,2.528,0,0,1,2.53,2.53V20.488a2.528,2.528,0,0,1-2.53,2.53H17.341V44.85H50.224a2.618,2.618,0,0,1,2.53,2.53V58.43a2.528,2.528,0,0,1-2.53,2.53H17.341v23.3H56.748a2.527,2.527,0,0,1,2.53,2.529V97.7a2.528,2.528,0,0,1-2.53,2.53H2.564A2.528,2.528,0,0,1,.034,97.7Z",
  transform: "translate(0.008 1.725)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1938",
  "data-name": "Path 1938",
  d: "M88.162,23.017H67.792a2.528,2.528,0,0,1-2.529-2.53V9.57a2.527,2.527,0,0,1,2.529-2.529h58.179A2.528,2.528,0,0,1,128.5,9.57V20.487a2.529,2.529,0,0,1-2.53,2.53H105.6V97.7a2.618,2.618,0,0,1-2.529,2.529H90.69A2.618,2.618,0,0,1,88.162,97.7Z",
  transform: "translate(15.992 1.725)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1939",
  "data-name": "Path 1939",
  d: "M137.869,9.57a2.62,2.62,0,0,1,2.53-2.53H152.78a2.528,2.528,0,0,1,2.53,2.53V44.85h43.4V9.57a2.528,2.528,0,0,1,2.53-2.53h12.247a2.619,2.619,0,0,1,2.53,2.53V97.7a2.619,2.619,0,0,1-2.53,2.53H201.24a2.528,2.528,0,0,1-2.53-2.53V60.96h-43.4V97.7a2.528,2.528,0,0,1-2.53,2.53H140.4a2.62,2.62,0,0,1-2.53-2.53Z",
  transform: "translate(33.783 1.725)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1940",
  "data-name": "Path 1940",
  d: "M226.944,41.65a2.528,2.528,0,0,1,2.529-2.53h11.05a2.528,2.528,0,0,1,2.53,2.53V89.844a2.618,2.618,0,0,1-2.53,2.529h-11.05a2.618,2.618,0,0,1-2.529-2.529Z",
  transform: "translate(55.609 9.586)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1941",
  "data-name": "Path 1941",
  d: "M328.023,96.891a48.662,48.662,0,1,0-16.208,4.968l11.243,32.935a3.5,3.5,0,0,0,3.311,2.374h12.155a2.344,2.344,0,0,0,2.219-3.1ZM276.067,53.965a29.918,29.918,0,1,1,29.918,29.918,29.952,29.952,0,0,1-29.918-29.918",
  transform: "translate(63.152 1.398)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1942",
  "data-name": "Path 1942",
  d: "M247.344,17.348A11.64,11.64,0,1,1,235.7,5.707a11.641,11.641,0,0,1,11.641,11.641",
  transform: "translate(54.903 1.398)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1943",
  "data-name": "Path 1943",
  d: "M346.941,10.5a10.119,10.119,0,0,1-3.076,7.423,10.492,10.492,0,0,1-14.847,0A10.115,10.115,0,0,1,325.94,10.5a10.118,10.118,0,0,1,3.078-7.424,10.495,10.495,0,0,1,14.847,0,10.122,10.122,0,0,1,3.076,7.424m-1.408,0a8.858,8.858,0,0,0-2.664-6.458,9.012,9.012,0,0,0-12.856,0,8.858,8.858,0,0,0-2.664,6.458,8.858,8.858,0,0,0,2.664,6.458,9.012,9.012,0,0,0,12.856,0,8.858,8.858,0,0,0,2.664-6.458M343.2,15.843H340.5l-4.019-4.309h-1.966v4.309h-2V4.735h3.787a14.925,14.925,0,0,1,1.881.1,4.308,4.308,0,0,1,1.457.474,2.847,2.847,0,0,1,1.123,1,2.791,2.791,0,0,1,.359,1.475,2.868,2.868,0,0,1-.686,1.96,4.674,4.674,0,0,1-1.887,1.245Zm-4.273-7.927a1.714,1.714,0,0,0-.171-.777,1.309,1.309,0,0,0-.57-.559,2.364,2.364,0,0,0-.8-.266,7.681,7.681,0,0,0-1.068-.061h-1.809V10h1.541a6.335,6.335,0,0,0,1.3-.116,2.129,2.129,0,0,0,.9-.393,1.726,1.726,0,0,0,.528-.669,2.384,2.384,0,0,0,.152-.91",
  transform: "translate(79.867 0)",
  fill: "#c00100"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1944",
  "data-name": "Path 1944",
  d: "M297.429,95.687a3.467,3.467,0,1,1-1.015-2.449,3.338,3.338,0,0,1,1.015,2.449m-.463,0a2.921,2.921,0,0,0-.88-2.13,2.972,2.972,0,0,0-4.242,0,3.025,3.025,0,0,0,0,4.262,2.975,2.975,0,0,0,4.242,0,2.924,2.924,0,0,0,.88-2.132M296.2,97.45h-.9l-1.326-1.422h-.649V97.45h-.661V93.785h1.25a4.977,4.977,0,0,1,.621.032,1.43,1.43,0,0,1,.481.156.941.941,0,0,1,.37.331.913.913,0,0,1,.118.487.939.939,0,0,1-.227.646,1.543,1.543,0,0,1-.623.411Zm-1.411-2.616a.568.568,0,0,0-.057-.256.427.427,0,0,0-.188-.184.793.793,0,0,0-.265-.088,2.7,2.7,0,0,0-.352-.02h-.6v1.238h.509a2.14,2.14,0,0,0,.428-.037.7.7,0,0,0,.3-.131.563.563,0,0,0,.174-.22.751.751,0,0,0,.051-.3",
  transform: "translate(71.183 22.598)",
  fill: "#c00100"
}));

function SvgRedLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 426.808,
    height: 138.565,
    viewBox: "0 0 426.808 138.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLogo);
export default __webpack_public_path__ + "static/media/red-logo.7aa7b42c6bb42177254a19059724d343.svg";
export { ForwardRef as ReactComponent };